// extracted by mini-css-extract-plugin
export default {"container":"InjectToken_container__0Ie0n","token-input":"InjectToken_token-input__RIDYP","import-btn":"InjectToken_import-btn__c7r95","tier":"InjectToken_tier__13dgu"};